import * as React from 'react';

import { classNames } from '../../../helpers';
import type { ITypeModifier } from '../TypeHelper';
import { getTypeModifierClasses } from '../TypeHelper';

export interface IInputProps extends ITypeModifier {
	type: 'text' | 'password' | 'email' | 'number';
	placeholder?: string;
	size?: 'small' | 'medium' | 'large';
	value?: string;
	autoFocus?: boolean;
	isDisabled?: boolean;
	onChange?: (value: string) => void;
	onKeyUp?: (event: any) => void;
	maxLength?: number;
	style?: React.CSSProperties;
}

interface IComponentState {
	value: string;
}

export default class Input extends React.Component<
	IInputProps,
	IComponentState
> {
	constructor(props: IInputProps) {
		super(props);
		this.state = {
			value: props.value ? props.value : '',
		};
	}

	public componentWillReceiveProps(nextProps: IInputProps) {
		if (nextProps.value !== this.props.value) {
			this.setState({
				...this.state,
				value: nextProps.value,
			});
		}
	}

	public handleInputChange = (e: any) => {
		this.setState({
			...this.state,
			value: e.target.value,
		});

		if (this.props.onChange) {
			this.props.onChange(e.target.value);
		}
	};

	public render() {
		const {
			size,
			placeholder,
			type,
			onKeyUp,
			autoFocus,
			isDisabled,
			maxLength,
			style,
			...others
		} = this.props;

		const classes = classNames(
			'input',
			size && `is-${size}`,
			getTypeModifierClasses(this.props)
		);

		const dataProps = Object.keys(others)
			.filter((x) => x.startsWith('data-'))
			.reduce((obj, key) => {
				obj[key] = others[key];
				return obj;
			}, {});

		return (
			<input
				style={style}
				className={classes}
				type={type}
				placeholder={placeholder}
				value={this.state.value}
				disabled={isDisabled}
				onChange={this.handleInputChange}
				onKeyUp={onKeyUp}
				autoFocus={autoFocus}
				maxLength={maxLength}
				{...dataProps}
			/>
		);
	}
}
